/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContactPersonVm,
    ContactPersonVmFromJSON,
    ContactPersonVmFromJSONTyped,
    ContactPersonVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContactPersonVmPaginatedSearchResponse
 */
export interface ContactPersonVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<ContactPersonVm>}
     * @memberof ContactPersonVmPaginatedSearchResponse
     */
    items?: Array<ContactPersonVm> | null;
    /**
     * 
     * @type {number}
     * @memberof ContactPersonVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactPersonVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactPersonVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactPersonVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactPersonVmPaginatedSearchResponse
     */
    size?: number;
}

export function ContactPersonVmPaginatedSearchResponseFromJSON(json: any): ContactPersonVmPaginatedSearchResponse {
    return ContactPersonVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function ContactPersonVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPersonVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(ContactPersonVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function ContactPersonVmPaginatedSearchResponseToJSON(value?: ContactPersonVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(ContactPersonVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


